import { useEffect, useState } from "react";
import styled from "styled-components";
import { HOST_URL, reqOptions, SK_VALUE } from "../../assets/js/helpFunction";
import Swal from "sweetalert2";
import PdfViewer from "./PdfViewer";
import AdsTerms from "./AdsTerms";

const RequestAdForm = () => {
  const goalsApi = `${HOST_URL()}estate_adverts/advertising-goals/`;

  const submitApi = `${HOST_URL()}estate_adverts/advertiser-info/`;

  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    business_name: "",
    full_name: "",
    email_address: "",
    phone_number: "",
    target_audience: "",
    title: "",
    category_of_service: "GROCERIES_SHOPPING",
    product_type: "",
    advert_goal: [],
  });

  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    let requestOptions = reqOptions("get");
    fetch(goalsApi, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data?.results) {
          setGoals(data?.results);
        }
      })
      .catch((err) => console.log("err", err));
  }, []);

  const handleCheck = (e, goal) => {
    if (form.advert_goal.includes(goal.id)) {
      setForm({
        ...form,
        advert_goal: form.advert_goal.filter((gl) => gl !== goal.id),
      });
    } else {
      setForm({
        ...form,
        advert_goal: [...form.advert_goal, goal.id],
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      business_name,
      full_name,
      email_address,
      phone_number,
      target_audience,
      title,
      category_of_service,
      product_type,
      advert_goal,
    } = form;
    if (
      !business_name ||
      !full_name ||
      !email_address ||
      !phone_number ||
      !target_audience ||
      !title ||
      !category_of_service ||
      !product_type ||
      !advert_goal
    ) {
      return alert("Please complete the form");
    }

    const requestOptions = {
      method: "post",
      headers: {
        "EstateIQ-Sk-Header": SK_VALUE(),
        // "X-CSRFToken": getCookie("CSRF-TOKEN"),
        // Origin: window.location.origin,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    };

    setLoading(true);
    fetch(submitApi, requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          Swal.fire({
            title: `Thank you for your interest! Your information has been received and will be reviewed shortly.`,
            icon: "success",
            showConfirmButton: true,
            showCloseButton: true,
          });
          return setForm({
            business_name: "",
            full_name: "",
            email_address: "",
            phone_number: "",
            target_audience: "",
            title: "",
            category_of_service: "GROCERIES_SHOPPING",
            product_type: "",
            advert_goal: [],
          });
        }
      })
      .catch((err) =>
        Swal.fire({
          title: `An error occurred, pls try again later.`,
          icon: "error",
          showConfirmButton: true,
          showCloseButton: true,
        })
      )
      .finally(() => setLoading(false));
  };

  return (
    <section className="webContainer">
      <RequestAd>
        <div className="mainForm">
          <h1>Interest Form</h1>
          <p>Thank you for your interest in advertising with us!</p>
          <p>Please take a moment to complete this short form.</p>
          <p>
            Register your interest in utilizing our in-app advertising services.
            We will use this information for an internal assessment and a
            personalized follow-up consultation.
          </p>
          <p>
            Your data is kept confidential and will only be used to facilitate
            this service inquiry.
          </p>
          <input
            type="text"
            value={form.business_name}
            onChange={(e) =>
              setForm({ ...form, business_name: e.target.value })
            }
            placeholder="Business/Trading Name"
          />
          <input
            type="text"
            value={form.full_name}
            onChange={(e) => setForm({ ...form, full_name: e.target.value })}
            placeholder="Contact Person (Full Name)"
          />
          <input
            type="text"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            placeholder="Title/Role"
          />
          <input
            type="text"
            value={form.email_address}
            onChange={(e) =>
              setForm({ ...form, email_address: e.target.value })
            }
            placeholder="Email Address"
          />
          <input
            type="text"
            value={form.phone_number}
            onChange={(e) => setForm({ ...form, phone_number: e.target.value })}
            placeholder="Phone Number"
          />
          {/* <input
            type="text"
            placeholder="Preferred Method for Follow-up: (Email / Phone Call / Virtual Meeting)"
          /> */}

          <textarea
            type="text"
            value={form.target_audience}
            onChange={(e) =>
              setForm({ ...form, target_audience: e.target.value })
            }
            placeholder="Target Audience (Brief Description)"
          />
          <p style={{ marginTop: "15px" }}>
            Primary Goal for Advertising with Us (Check all that apply):
          </p>

          {goals?.map((goal) => (
            <label
              key={goal?.id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <input
                checked={form.advert_goal.includes(goal.id)}
                onChange={(e) => handleCheck(e, goal)}
                type="checkbox"
                style={{ marginRight: 8, width: "fit-content", marginTop: 0 }}
              />
              <span style={{ width: "100%" }}>{goal?.goals}</span>
            </label>
          ))}
          <p style={{ marginTop: "15px" }}>Category of services</p>

          <select
            style={{
              display: "block",
              width: "100%",
              height: "auto",
              padding: "15px",
              fontSize: "16px",
              lineHeight: "1.4",
              color: "#2c333a",
              backgroundColor: "#fff",
              border: "1px solid #dfe3e7",
              borderRadius: "5px",
              transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
            }}
            value={form.category_of_service}
            onChange={(e) =>
              setForm({ ...form, category_of_service: e.target.value })
            }
          >
            {[
              "GROCERIES_SHOPPING",
              "HEALTH_AND_WELLNESS",
              "ELECTRONIC_&_HOME_APPLIANCES",
              "FASHION_AND_LIFESTYLE",
              "AUTOMOBILE",
              "EDUCATION_&_TRAINING",
              "DELIVERY",
              "FARM_PRODUCE",
              "OTHERS",
            ].map((optionToUse) => (
              <option key={optionToUse} value={optionToUse} id={optionToUse}>
                {optionToUse.replaceAll("_", " ")}
              </option>
            ))}
          </select>
          <textarea
            value={form.product_type}
            onChange={(e) => setForm({ ...form, product_type: e.target.value })}
            placeholder="List your products/services here"
          />
          <h3 style={{ textAlign: "center", marginTop: 10, marginBottom: 10 }}>
            Terms and Conditions
          </h3>
          <div style={{ width: "100%", height: "500px", overflowY: "scroll" }}>
            <AdsTerms />
          </div>

          <div
            style={{
              display: "flex",
              gap: 8,
              flexDirection: "row",
              marginTop: 30,
              alignItems: "center",
            }}
          >
            <div
              onClick={() => setAgreed(!agreed)}
              style={{
                width: 25,
                height: 25,
                borderRadius: 7,
                border: "1px solid",
                borderColor: agreed ? "#2d4bf3" : "#ccc",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              {!!agreed && (
                <div
                  style={{
                    background: "#2d4bf3",
                    borderRadius: "5px",
                    width: 16,
                    height: 16,
                  }}
                />
              )}
            </div>
            <p>I have read and agreed to the above terms and conditions</p>
          </div>
          <button
            onClick={handleSubmit}
            className="important-btn"
            disabled={!agreed}
          >
            {loading ? "Sending..." : "Send"}
          </button>
        </div>
      </RequestAd>
    </section>
  );
};

export default RequestAdForm;

let RequestAd = styled.form`
  border: 1.5px solid #999999;
  margin: 0 auto;
  margin-top: 150px;
  max-width: 700px;
  border-radius: 5px;
  .mainForm {
    background: #ffffff;
    padding: 50px 20px;
    margin: 0 auto;
    max-width: 600px;
    h1 {
      font-size: 35px;
      font-weight: 700;
      line-height: 41px;
      margin-bottom: 40px;
      letter-spacing: 0px;
      text-align: center;
    }
    input,
    textarea {
      margin-top: 20px;
    }
    button {
      width: 100%;
    }
  }
`;
